import React, {Fragment} from 'react';

// @ts-ignore
import {getFAQInnerScript} from '@stencil/gi-faq';

interface ISeoFaQ {
  datakey: string;
  faqData?: {};
  id?: string;
}

const SeoFaq = ({datakey, faqData, id = 'faqs'}: ISeoFaQ) => {
  return (
    <Fragment>
      <seo-faq faqdatakey={datakey} id={id}></seo-faq>
      <span dangerouslySetInnerHTML={getFAQInnerScript({template: datakey, faqData})}></span>
    </Fragment>
  );
};

export default SeoFaq;
